/**
 * Users
 */

// React
import React, { FunctionComponent, useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';

import RenderFilter from '../../utils/listDaynamicFilter';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  InputBase,
  IconButton,
  FormControl,
  ClickAwayListener,
  Select,
  MenuItem,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiMapMarkerRadiusOutline,
  mdiCheck,
  mdiClose,
  mdiMagnify,
  mdiWarehouse,
  mdiHomeCityOutline,
  mdiStateMachine,
  mdiKeyOutline,
} from '@mdi/js';

// Helper
import { removeEmptyValueObject } from '../../utils/helpers';

// Type
import { Props } from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';

import handleError from "../../utils/handleError";
import warehouseRepository from "client-sdk/src/Repository/warehouses-repository";

type Inputs = {
  'name.contains': string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    diactiveCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#ddd',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },

    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

// Const
const translate = {
  edit: 'ویرایش',
  detail: 'جزیيات مرکز',
  assign: 'لیست مراکز',
} as any;

const WarehouseChildren: FunctionComponent<Props> = (props: Props) => {
  const classes = useStyles();
  const { register, handleSubmit } = useForm<Inputs>();
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);
  const [id, setId] = useState(-1 as number);
  const [openFilterBox, setOpenFilterBox] = useState(false as boolean);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [warehousesChildrenList, setWarehousesChildrenList] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [count, setCount] = React.useState(0);
  const [warehousesList, setWarehousesList] = React.useState([]);

  useEffect(() => {
    getWarehouseChildren();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const warehousChildren = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const response = await warehouseRepository.getWarehouseChildren({ payload });
      setWarehousesChildrenList(response.data);
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  }

  const getWarehouseChildren = () => {
    const { page, size } = filtersValues;
    const { warehousesId } = props.match.params;
    warehousChildren({
      pagination: {
        ...removeEmptyValueObject(filtersValues),
        page,
        size
      },
      id: warehousesId
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام انبار',
        icon: mdiWarehouse,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه انبار',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'province.contains',
        label: 'استان',
        icon: mdiHomeCityOutline,
      },
      {
        type: 'input',
        id: 'city.contains',
        label: 'شهر',
        icon: mdiHomeCityOutline,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت ',
        data: ['ACTIVE', 'SUSPENDED'],
        translateType: 'CenterStatus',
        icon: mdiStateMachine,
      },
    ]);
  };

  const handleOpenConfirmDisable = (centerId: number) => {
    setOpenConfirmDisable(true);
    setId(centerId);
  };

  const handleOpenConfirmActive = (centerId: number) => {
    setOpenConfirmActive(true);
    setId(centerId);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
    setOpenDialog(false);
    setOpenSize(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    setOpenFilterBox(false);
  };

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };
  const updateWarehouseStatus = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const { pagination, callback } = await warehouseRepository.updateWarehouseStatus({ payload });
      callback && callback();
    } catch (error) {
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  }
  const handleDisableUser = async () => {
    await updateWarehouseStatus({
      id,
      body: 'SUSPENDED'.replace(/'/g, '"'),
      pagination: filtersValues,
      callback: () => getWarehouseChildren(),
    });
    setOpenConfirmDisable(false);
  };

  const handleActiveUser = async () => {
    await updateWarehouseStatus({
      id,
      body: 'ACTIVE'.replace(/'/g, '"'),
      pagination: filtersValues,
      callback: () => getWarehouseChildren(),
    });

    setOpenConfirmActive(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={6}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`لیست انبارهای زیر مجموعه انبار
           ${warehousesList.find(
                item => item.id == props.match.params?.warehousesId
              )?.name
                }
            `}
            </Typography>
            <span className={classes.contentlabelTitle}>
              {props.match.params?.warehousesId}
            </span>
          </div>

          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.searchBox}>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.input}>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
              >
                <Icon
                  path={mdiMagnify}
                  size={1}
                  className={classes.magnifyIcon}
                />
              </IconButton>
              <InputBase
                className={classes.input}
                name="name.contains"
                placeholder="نام انبار "
                inputRef={register({ required: true })}
                inputProps={{ 'aria-label': 'search google maps' }}
              />
            </form>
            <ClickAwayListener onClickAway={handleClickAway}>
              <div>
                <Button
                  type="button"
                  onClick={handleClick}
                  className={classes.iconButton}
                  aria-label="search"
                >
                  فیلترها
                </Button>
                {openFilterBox ? (
                  <div
                    className={clsx(classes.filterBox, {
                      [classes.filterOpen]: openFilterBox,
                    })}
                  >
                    <RenderFilter
                      filters={filters}
                      onFilter={(filtervalues: any) => {
                        setFiltersValues({
                          ...filtervalues,
                          page: 0,
                          size: 10,
                          // partnerId: {
                          //   equals: props.match.params.warehousesId || null,
                          // },
                        });
                        setOpenFilterBox(false);
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </ClickAwayListener>
          </div>
        </Grid>

        <Grid item xs={4}>
          <div className={classes.box}>
            <div className={classes.allCenter}>
              <Icon
                size={2}
                path={mdiMapMarkerRadiusOutline}
                style={{ color: '#B297A7' }}
              />
            </div>
            <div className={classes.title}>کل مراکز:</div>
            <div className={classes.text}>
              {warehousesChildrenList?.length}
            </div>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div className={classes.box}>
            <div className={classes.activeCenter}>
              <Icon size={2} path={mdiCheck} style={{ color: '#039590' }} />
            </div>
            <div className={classes.title}>مراکز فعال:</div>
            <div className={classes.text}>
              {
                warehousesChildrenList.filter(
                  child => child?.status === 'ACTIVE'
                )?.length
              }
            </div>
          </div>
        </Grid>

        <Grid item xs={4}>
          <div className={classes.box}>
            <div className={classes.diactiveCenter}>
              <Icon size={2} path={mdiClose} style={{ color: '#F30000' }} />
            </div>
            <div className={classes.title}>مراکز غیر فعال:</div>
            <div className={classes.text}>
              {
                warehousesChildrenList.filter(
                  child => child?.status === 'SUSPENDED'
                )?.length
              }
            </div>
          </div>
        </Grid>

        <Grid item xs={12}>
          <Grid container item spacing={6}>
            <Grid item xs={12}>
              {loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <List
                  data={warehousesChildrenList}
                  handleOpenConfirmDisable={handleOpenConfirmDisable}
                  handleOpenConfirmActive={handleOpenConfirmActive}
                  handleOpen={handleOpen}
                  changeStatus={handleOpenConfirmUpdateState}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {warehousesList.length > 0 && (
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={handleClose}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
              )}
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              {warehousesList.length > 0 && (
                <Pagination
                  className={classes.pagination}
                  count={Math.ceil(count / filtersValues.size)}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>


      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div
            className={
              openConfirmDisable ? classes.cancelIcon : classes.editIcon
            }
          >
            {openConfirmDisable ? (
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            ) : (
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            )}
          </div>
          <div className={classes.cancelTitle}>
            {` آیا از 
            
            ${openConfirmDisable ? 'غیر' : ''}
            فعال کردن انبار با نام
          "${warehousesChildrenList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              {openConfirmDisable ? (
                <Button
                  onClick={handleDisableUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              ) : (
                <Button
                  onClick={handleActiveUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{` 
          ${translate[type]}
        "${warehousesChildrenList.find(center => center.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          {/* {type === 'detail' && (
            <Detail data={props.centersList.find(center => center.id === id)} />
          )} */}
        </DialogContent>
      </Dialog>
    </div>
  );
};

// const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
//   warehousesChildrenList: makeSelectChildrenList(),
//   loading: makeSelectLoading(),
//   count: makeSelectCountList(),
//   warehousesList: makeSelectList(),
//   error: makeSelectError(),
// });

// function mapDispatchToProps(dispatch: Function) {
//   return {
//     warehousChildrenDispatch: (payload: {id: number; pagination: object}) =>
//       dispatch(getWarehouseChildrenAction(payload)),
//     updateWarehouseStatusDispatch: (payload: {
//       id: number;
//       body: string;
//       pagination: object;
//       callback?: () => void;
//     }) => dispatch(updateWarehousesStatusActions(payload)),
//   };
// }

// const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default WarehouseChildren;
